// OPS Occult Library editorial copy cleanup v1 — remove generic hand-holding and meta commentary.
(()=>{
  const instructionalHeading=(heading='')=>{
    const h=String(heading).trim();
    return [
      /^Artist research:/i,
      /^Tattoo reference:/i,
      /^Follow .*source trail/i,
      /^Lettering research:/i,
      /^Music and album-art research:/i,
      /^Illustration and graphic-design research:/i,
      /^Album art and worldbuilding:/i
    ].some((rx)=>rx.test(h));
  };

  const instructionalParagraph=(text='')=>[
    /^For visual research,/i,
    /^For artist research,/i,
    /^For artists,/i,
    /^For illustration,/i,
    /^For game (?:art|and worldbuilding)/i,
    /^For tattoo/i,
    /^For poster/i,
    /^For record/i,
    /^The artist-facing value/i,
    /^The useful design lesson/i,
    /^Use that historical/i,
    /^Start by /i,
    /^Start with /i,
    /^Try /i,
    /^Test /i,
    /^Continue through /i,
    /^Compare several historical/i
  ].some((rx)=>rx.test(String(text).trim()));

  const cleanSynopsis=(text='')=>String(text)
    .replace(/\s+For artists,[\s\S]*$/i,'')
    .replace(/\s+It is useful to artists[\s\S]*$/i,'')
    .replace(/\s+It is useful for artists[\s\S]*$/i,'')
    .replace(/\s+It is unusually useful source material[\s\S]*$/i,'')
    .trim();

  const cleanData=()=>{
    const entries=window.OPS_OCCULT_EDITORIAL?.entries;
    if(!Array.isArray(entries)) return;

    entries.forEach((entry)=>{
      if(entry.synopsis) entry.synopsis=cleanSynopsis(entry.synopsis);

      if(Array.isArray(entry.lead)){
        entry.lead=entry.lead.filter((p)=>!instructionalParagraph(p));
      }

      if(Array.isArray(entry.sections)){
        entry.sections=entry.sections
          .filter((section)=>!instructionalHeading(section?.heading))
          .map((section)=>{
            const next={...section};
            if(/^Historical context/i.test(next.heading||'')) next.heading='Historical context';
            if(Array.isArray(next.paragraphs)) next.paragraphs=next.paragraphs.filter((p)=>!instructionalParagraph(p));
            return next;
          })
          .filter((section)=>Array.isArray(section.paragraphs) ? section.paragraphs.length : true);
      }

      if(Array.isArray(entry.related)){
        entry.related=entry.related.filter((label)=>!/(?:artist|tattoo|album-art|record-cover|worldbuilding|game ui|graphic design|printmaking|creature design|visual rhythm).*?(?:research|reference|diagram)?$/i.test(String(label)) && !/(?:research|reference)$/i.test(String(label)));
      }
    });
  };

  const setText=(node,value)=>{
    if(node && node.textContent!==value) node.textContent=value;
  };

  const setHtml=(node,value)=>{
    if(node && node.innerHTML!==value) node.innerHTML=value;
  };

  const clean=()=>{
    document.querySelectorAll('.ops-library__media-head').forEach((head)=>{
      setText(head.querySelector('.ops-library__eyebrow'),'MEDIA');
      setText(head.querySelector('h3'),'Recordings & media');
      [...head.querySelectorAll(':scope > p')].forEach((p)=>{ if(!p.classList.contains('ops-library__eyebrow')) p.remove(); });
    });

    const browse=document.querySelector('.ops-library__browse-head');
    if(browse){
      setText(browse.querySelector('.ops-library__eyebrow'),'BROWSE');
      const prose=[...browse.querySelectorAll(':scope > p')].find((p)=>!p.classList.contains('ops-library__eyebrow'));
      setText(prose,'Browse by depth, subject or A–Z.');
    }

    setText(document.querySelector('.ops-library__list-heading h2'),'Archive entries');

    const note=document.querySelector('.ops-library__archive-note');
    if(note){
      const ps=[...note.querySelectorAll(':scope > p')];
      setText(ps[0],'Historical images, objects, texts and recorded traditions with source records and rights information where available.');
      setText(ps[1],'Unfinished research remains unpublished.');
    }

    const iceberg=document.querySelector('.ops-library__iceberg-head');
    if(iceberg){
      setText(iceberg.querySelector('h2'),'Occult iceberg');
      const prose=[...iceberg.querySelectorAll(':scope > p')].find((p)=>!p.classList.contains('ops-library__eyebrow'));
      setText(prose,'Finished entries grouped by archive depth.');
      setHtml(iceberg.querySelector('[data-random-rabbit]'),'Random entry <span aria-hidden="true">↝</span>');
    }

    document.querySelectorAll('.ops-library__rabbit-trails').forEach((trails)=>{
      if(trails.getAttribute('aria-label')!=='Related archive entries') trails.setAttribute('aria-label','Related archive entries');
      trails.querySelectorAll(':scope > div').forEach((group)=>{
        const eyebrow=group.querySelector('.ops-library__eyebrow')?.textContent?.trim();
        const h=group.querySelector('h3');
        if(!h) return;
        if(eyebrow==='RELATED') setText(h,'Related entries');
        if(eyebrow==='GO DEEPER') setText(h,'Deeper entries');
        if(eyebrow==='BROADER') setText(h,'Subject index');
      });
    });

    document.querySelectorAll('.ops-library__entry-copy > .ops-library__article-section > h3').forEach((h)=>{
      if(h.textContent.trim()==='Make something from it') setText(h,'Print & production');
    });

    document.querySelectorAll('.ops-library__evidence-note > span').forEach((span)=>{
      if(span.textContent.trim()==='Archive status') setText(span,'Source status');
    });
  };

  cleanData();

  const start=()=>{
    cleanData();
    clean();
    const root=document.querySelector('[data-ops-library]')||document.body;
    let queued=false;
    const observer=new MutationObserver(()=>{
      if(queued) return;
      queued=true;
      requestAnimationFrame(()=>{
        queued=false;
        observer.disconnect();
        cleanData();
        clean();
        observer.observe(root,{subtree:true,childList:true});
      });
    });
    observer.observe(root,{subtree:true,childList:true});
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
